import React, { useState } from 'react';
import PLAYER from '../playerData';
import { RESOURCES } from '../content/common';
import { ASSETS } from '../assetManifest';

function Building({ emoji, size = 40, built, onClick, selected }) {
  return (
    <div 
      className={`relative cursor-pointer transition-all duration-200 
        ${selected ? 'scale-110' : ''}`}
      onClick={onClick}
    >
      <div 
        style={{
          fontSize: `${size}px`,
          lineHeight: 1,
          height: `${size}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
        }}
      >
        {built && emoji}
      </div>
    </div>
  );
}

function MapStage({ map, refreshKey }) {
  const [selectedPosition, setSelectedPosition] = useState(null);

  const handleBuildingClick = (buildingId) => {
    map.selectBuilding(buildingId);
    setSelectedPosition(buildingId);
  };

  map.update();
  const selectedBuilding = selectedPosition !== null ? map.buildings[selectedPosition] : null;
  const canBuild = selectedBuilding && !selectedBuilding.built && PLAYER.resources.stars >= selectedBuilding.starCost;

  // Create 5x5 grid
  const grid = Array(5).fill().map(() => Array(5).fill(''));

  // Place decorations on grid
  map.decorations.forEach(decoration => {
    grid[decoration.row][decoration.col] = decoration.emoji;
  });

  // Place buildings on grid
  Object.values(map.buildings).forEach(building => {
    if (building.built) {
      grid[building.row][building.col] = building.emoji;
    }
  });

  return (
    <div className="h-full w-full relative" style={{ width: '390px', maxWidth: '100%', margin: '0 auto' }}>
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${ASSETS.backgrounds.mapBackground.path})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
          height: '100%'
        }}
      >
        <div className="w-[353px] h-[357px] absolute left-[18px] top-[223px]">
          <div 
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 65px)',
              gridTemplateRows: 'repeat(5, 65px)',
              gap: '7px',
            }}
          >
            {grid.map((row, i) => (
              row.map((cell, j) => {
                const building = Object.values(map.buildings).find(b => b.row === i && b.col === j);
                return (
                  <div 
                    key={`${i}-${j}`}
                    className="flex items-center justify-center"
                    style={{
                      width: '65px',
                      height: '65px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                      transform: building && selectedPosition === building.id ? 'scale(1.1)' : 'scale(1)',
                      backgroundImage: `url(${ASSETS.ui.gridCell.path})`,
                      backgroundSize: 'cover'
                    }}
                  >
                    {building ? (
                      <Building 
                        emoji={building.emoji}
                        built={building.built}
                        selected={selectedPosition === building.id}
                        onClick={() => handleBuildingClick(building.id)}
                      />
                    ) : (
                      <div style={{ fontSize: '40px' }}>{cell}</div>
                    )}
                  </div>
                );
              })
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MapStage;
